import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import clsx from 'clsx';
import { Link } from 'gatsby';

export default function UseCasesTiles({ blok }) {
  const { component } = blok;

  const styles = clsx(
    `${component} mt-[60px] lg:mt-20 grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-2 md:gap-6 px-4 lg:px-16`,
  );

  return (
    <div {...storyblokEditable(blok)} className={styles}>
      {blok?.use_case?.map((item) => (
        <div className="relative h-full overflow-hidden" key={item.title}>
          <Link
            key={item.slug}
            to={`/${item.full_slug}`}
            className="flex mx-auto aspect-[24/10] w-full relative group"
          >

            <img
              src={item?.content?.hero_image?.filename}
              alt={item.short_description}
              className="w-auto object-cover h-full absolute top-0 left-0"
            />

            <div className="bg-latori-green-dark opacity-90 w-full h-full absolute bottom-0 left-0 transition-[height] group-hover:h-[0%]" />
            <div className="w-full h-full absolute top-0 left-0 flex flex-col justify-center items-start px-4 group-hover:opacity-0 transition-opacity text-white">
              <h2 className="text-2xl">{item?.content?.title}</h2>
              <p
                dangerouslySetInnerHTML={{ __html: item?.content?.description }}
                className="hidden md:block md:line-clamp-3"
              />
            </div>
          </Link>
        </div>
      ))}
    </div>
  );
}
